import { getTemplate } from "../template-helper";
import { translateElement, tr } from "../../util/locales" ;
import { waiter } from "../../util/utils";
import { getSavePatch } from "../binding";
import { info } from "../../util/dialogs";

const COMPONENT_NAME = "z-button-print" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ButtonPrintComponent extends HTMLElement {
            constructor() {
                super();
                this.button = this.querySelector("button") ;
                if(!this.button){
                    const innerHtml = this.innerHTML ;
                    this.innerHTML = "" ;
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    translateElement(this) ;
                    this.button = this.querySelector("button") ;
                    if(innerHtml){
                        this.button.innerHTML = innerHtml ;
                    }
                }

                
                this.addEventListener("click", ()=>{
                    this.onPrint() ;
                }) ;
            }

            get disabled() {
                return this.button.getAttribute("disabled") ;
            }
            
            set disabled(disabled) {
                this.button.setAttribute("disabled", disabled) ;
            }

            static get observedAttributes() {
                return ['disabled'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'disabled':
                        this.disabled = newValue ;
                    break;
                }
            }

            onPrint(){
                

                const templateCode = this.getAttribute("z-template") ;
                const templateLang = this.getAttribute("z-lang") ;
                let templateModel = this.getAttribute("z-model") ;
                let  templateSearch = this.getAttribute("z-search") ;
                let templateFilename = this.getAttribute("z-filename") ;
                if(!templateModel){
                    //model not specified, see if we are inside a form
                    const zForm = this.closest("z-form") ;
                    if(zForm && zForm.hasAttribute("z-model")){
                        templateModel = zForm.getAttribute("z-model") ;
                    }else{
                        const zList = this.closest("z-list") ;
                        if(zList && zList.hasAttribute("z-model")){
                            templateModel = zList.getAttribute("z-model") ;
                        }else{
                            throw "missing model on button print" ;
                        }   
                    }
                }
                if(!templateSearch){
                    //model not specified, see if we are inside a form
                    const zForm = this.closest("z-form") ;
                    if(zForm){
                        const {data} = getSavePatch(this) ;
                        templateSearch = {_id: data._id} ;
                    }else{
                        const zList = this.closest("z-list") ;
                        if(zList){
                            //FIXME: get the selection in grid
                            templateSearch = {} ;
                        }else{
                            throw "missing search on button print" ;
                        }   
                    }
                }
                const query = [
                    {
                      code: "model",
                      value: templateModel
                    },
                    {
                      code: "search",
                      value: templateSearch
                    },
                    {
                      code: "code",
                      value: templateCode
                    },
                    {
                      code: "lang",
                      value: templateLang
                    },
                    {
                      code: "filename",
                      value: templateFilename
                    },
                ]
                .filter(q=>{ return q.value ; })
                .map(q=>{
                    let value = q.value;
                    if(typeof(value) === "object"){
                        value = JSON.stringify(value) ;
                    }
                    return q.code+"="+encodeURIComponent(value) ;
                }).join("&") ;
                let responseFilename ;
                waiter(
                    fetch("/printLink?"+query).then((response)=>{
                        if(response.status < 200 || response.status > 299){
                            return response.text().then((text)=>{
                                let msg = text;
                                try{
                                    msg = JSON.parse(text) ;
                                }catch(e){
                                    //ignore parse error, it is not a JSON object
                                }
                                if(!msg){
                                    msg = "error" ; 
                                }
                                throw msg ;
                            }) ;
                        }
                        let disposition = response.headers.get("content-disposition") ;
                        if(disposition){
                            const indexStart = disposition.indexOf('="') ;
                            if(indexStart !== -1){
                                const indexEnd = disposition.indexOf('"', indexStart+2) ;
                                if(indexEnd !== -1){
                                    responseFilename = disposition.substring(indexStart+2, indexEnd) ;
                                }
                            }
                        }
                        return response.arrayBuffer(); 
                    }).then(buffer => {
                        var file = new Blob([buffer], {type: 'application/pdf'});
                        var a = document.createElement("a");
                        document.body.appendChild(a);
                        a.style = "display: none";
                        const url = window.URL.createObjectURL(file);
                        a.href = url;
                        a.download = responseFilename||tr("form.printDefaultName");
                        a.click();
                        window.URL.revokeObjectURL(url);
                        document.body.removeChild(a) ;
                    })
                ) ;
            }
        }
        customElements.define(COMPONENT_NAME, ButtonPrintComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
